import { faVideoCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import { TrlFormattedMessagePlain } from '»utils/i18n';

import { PillContainer } from './TrlVideoPill.styles';

export const TrlVideoPill = ({ handleOnClick, hide }) => (
  <PillContainer
    icon={<FontAwesomeIcon icon={faVideoCamera} />}
    label={TrlFormattedMessagePlain({ id: 'TRLT_UI-VIDEO' })}
    onClick={handleOnClick}
    hide={hide}
  />
);

TrlVideoPill.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
  hide: PropTypes.bool,
};
